import React from 'react';

const XLogoSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#fff" stroke="4a4a4a">
    <path stroke="#4a4a4a" d="M8.08 6.07 12.3.93h-1L7.63 5.39 4.7.93H1.32l4.43 6.74-4.43 5.39h1l3.87-4.71 3.09 4.71h3.38L8.07 6.07zM6.71 7.74l-.45-.67-3.57-5.34h1.54l2.88 4.31.45.67 3.75 5.61H9.77L6.71 7.75z"/>
  </svg>
);

export default XLogoSvg;
